import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f843f50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "order__content" }
const _hoisted_3 = { class: "order__title order-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-title__title" }, "Ваш заказ", -1))
const _hoisted_5 = { class: "order-title__counters" }
const _hoisted_6 = { class: "order-title__dishes-number" }
const _hoisted_7 = {
  key: 0,
  class: "order-title__restaurants"
}
const _hoisted_8 = {
  key: 0,
  class: "order-title__card-discount"
}
const _hoisted_9 = { class: "rouble-symbol" }
const _hoisted_10 = {
  key: 1,
  class: "order-title__bonuses-accrual-sum"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "будет начислено бонусов", -1))
const _hoisted_12 = { class: "sum" }
const _hoisted_13 = { class: "order__items order-items" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 1,
  class: "order__delivery-message delivery-message"
}
const _hoisted_16 = {
  key: 2,
  class: "order__delivery-message delivery-message"
}
const _hoisted_17 = { class: "rouble-symbol" }
const _hoisted_18 = {
  key: 3,
  class: "delivery-prices"
}
const _hoisted_19 = {
  key: 0,
  class: "delivery-prices__list"
}
const _hoisted_20 = {
  key: 0,
  class: "order__delivery-price delivery-price"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Доставка", -1))
const _hoisted_22 = { class: "delivery-price__price rouble-symbol" }
const _hoisted_23 = { class: "delivery-price__price rouble-symbol" }
const _hoisted_24 = {
  key: 1,
  class: "order__delivery-address"
}
const _hoisted_25 = { class: "order__total total" }
const _hoisted_26 = {
  key: 0,
  class: "total__card-discount"
}
const _hoisted_27 = { class: "rouble-symbol" }
const _hoisted_28 = { class: "total__info" }
const _hoisted_29 = {
  key: 0,
  class: "total__delivery-time delivery-time"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "delivery-time__title" }, "Время доставки", -1))
const _hoisted_31 = { class: "delivery-time__description" }
const _hoisted_32 = { class: "total__order-price order-price" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-price__title" }, "Итого", -1))
const _hoisted_34 = { class: "order-price__description rouble-symbol" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderWarning = _resolveComponent("OrderWarning")!
  const _component_OrderItem = _resolveComponent("OrderItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_OrderWarning, {
      "work-schedule": _ctx.companyStore.activeCompany?.workSchedule,
      "is-delayed-order": !!_ctx.orderStore.cookingTime
    }, null, 8, ["work-schedule", "is-delayed-order"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.orderStore.totalItemsQuantity) + " " + _toDisplayString(_ctx.pluralize(_ctx.orderStore.totalItemsQuantity, ['блюдо', 'блюда', 'блюд'])), 1),
          (_ctx.restaurantCount > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.restaurantCount) + " " + _toDisplayString(_ctx.pluralize(_ctx.restaurantCount, ['ресторан', 'ресторана', 'ресторанов'])), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.orderStore.activeOrder.totalCardDiscount > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_ctx.CARD_TYPE_TITLES[_ctx.orderStore.activeOrder.cardType]), 1),
              _createElementVNode("span", _hoisted_9, " -" + _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder.totalCardDiscount)), 1)
            ]))
          : _createCommentVNode("", true),
        (+_ctx.orderStore.activeOrder.bonusesAccrualSum > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder.bonusesAccrualSum)) + " ББ ", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderStore.activeOrder.items, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "order-items__item"
          }, [
            _createVNode(_component_OrderItem, {
              "order-item": item,
              "is-visible-restaurant": _ctx.restaurantCount > 1,
              onToggleFastView: ($event: any) => (_ctx.openFastView(item.product, item.productOption))
            }, null, 8, ["order-item", "is-visible-restaurant", "onToggleFastView"])
          ]))
        }), 128))
      ]),
      (!_ctx.orderStore.isAvailableDeliveryTypes)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "order__delivery-message delivery-message",
            innerHTML: _ctx.orderStore.deliveryTypesTerms
          }, null, 8, _hoisted_14))
        : _createCommentVNode("", true),
      (_ctx.isVisibleDeliveryMessage && !_ctx.orderStore.activeOrder?.companyUserDeliveryAddress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Укажите адрес доставки "))
        : _createCommentVNode("", true),
      (_ctx.isVisibleDeliveryMessage && _ctx.orderStore.priceForDelivery)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createTextVNode(" Закажите еще на "),
            _createElementVNode("b", _hoisted_17, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.priceForDelivery)), 1),
            _createTextVNode(" для " + _toDisplayString(_ctx.orderStore.activeOrder.deliveryPrice ? '' : 'бесплатной') + " доставки или выберите другой адрес ", 1)
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.orderStore.deliveryPrices.main ||
          _ctx.orderStore.deliveryPrices.isVisibleRestaurants ||
          _ctx.orderStore.deliveryAddress
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (_ctx.orderStore.deliveryPrices.main || _ctx.orderStore.deliveryPrices.isVisibleRestaurants)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_ctx.orderStore.deliveryPrices.main)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.deliveryPrices.main)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.orderStore.deliveryPrices.isVisibleRestaurants)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.orderStore.deliveryPrices.restaurants, (restaurant) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: restaurant.id,
                          class: "order__delivery-price delivery-price"
                        }, [
                          _createElementVNode("span", null, " Доставка «" + _toDisplayString(restaurant.name) + "» ", 1),
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$filters.formattedNumber(restaurant.price)), 1)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.orderStore.deliveryAddress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.orderStore.deliveryAddress), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        (_ctx.orderStore.activeOrder.totalCardDiscount > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("span", null, _toDisplayString(_ctx.CARD_TYPE_TITLES[_ctx.orderStore.activeOrder.cardType]), 1),
              _createElementVNode("span", _hoisted_27, " -" + _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder.totalCardDiscount)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_28, [
          (_ctx.orderStore.deliveryTime)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.orderStore.deliveryTime), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder.totalPrice)), 1)
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "order__process-btn base-btn base-btn--green",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToCart && _ctx.goToCart(...args)))
      }, " Оформить заказ ")
    ])
  ]))
}